/** Notifications API calls (typed). List is read + mark-read mutations only. */

import { apiGet, apiPatch, type PaginatedResponse, type QueryParams } from "@/lib/api-client";
import type { ApiNotification } from "./notifications.adapter";

export interface NotificationsListParams {
  page?: number;
  limit?: number;
  search?: string;
  severity?: string;
  isRead?: boolean;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
}

export const notificationsApi = {
  list: (params: NotificationsListParams = {}) =>
    apiGet<PaginatedResponse<ApiNotification>>("/notifications", params as QueryParams),
  markRead: (id: string) => apiPatch<ApiNotification>(`/notifications/${id}/read`),
  markAllRead: () => apiPatch<{ count: number }>("/notifications/read-all"),
};
